(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bespoke-appointment-booking"] && !Shopify.designMode) return;
  try {
    
  function initializeBespokeBooking(section) {
    if (section.dataset.bespokeBookingInitialized === 'true') return;
    section.dataset.bespokeBookingInitialized = 'true';

    const dialog = section.querySelector('[data-bespoke-booking-dialog]');
    const openButton = section.querySelector('[data-bespoke-booking-open]');
    const closeButton = section.querySelector('[data-bespoke-booking-close]');
    const backButton = section.querySelector('[data-bespoke-booking-back]');
    const locationsView = section.querySelector('[data-bespoke-booking-locations]');
    const calendarView = section.querySelector('[data-bespoke-booking-calendar]');
    const calendarTitle = section.querySelector('[data-bespoke-booking-calendar-title]');
    const iframe = section.querySelector('[data-bespoke-booking-iframe]');
    const fallback = section.querySelector('[data-bespoke-booking-fallback]');
    const unavailable = section.querySelector('[data-bespoke-booking-unavailable]');
    const externalLink = section.querySelector('[data-bespoke-booking-external]');
    const locationButtons = section.querySelectorAll('[data-bespoke-booking-location]');
    const iframeBaseTitle = iframe?.title || '';

    if (!dialog || !openButton) return;

    function resetCalendar() {
      iframe.src = 'about:blank';
      iframe.hidden = true;
      fallback.hidden = true;
      unavailable.hidden = true;
      calendarView.hidden = true;
      locationsView.hidden = false;
      calendarTitle.textContent = '';
      iframe.title = iframeBaseTitle;
    }

    function canEmbed(url) {
      try {
        const hostname = new URL(url).hostname.toLowerCase();
        return hostname === 'calendly.com'
          || hostname.endsWith('.calendly.com')
          || hostname === 'cal.com'
          || hostname.endsWith('.cal.com')
          || hostname === 'calendar.google.com';
      } catch {
        return false;
      }
    }

    function embedUrl(url) {
      const parsedUrl = new URL(url);

      if (parsedUrl.hostname === 'calendly.com' || parsedUrl.hostname.endsWith('.calendly.com')) {
        parsedUrl.searchParams.set('hide_gdpr_banner', '1');
        parsedUrl.searchParams.set('background_color', 'ffffff');
        parsedUrl.searchParams.set('text_color', '1d1d1d');
        parsedUrl.searchParams.set('primary_color', '1d1d1d');
      }

      return parsedUrl.toString();
    }

    function openLocation(button) {
      const url = button.dataset.bookingUrl || '';
      const fallbackUrl = button.dataset.bookingFallbackUrl || '';
      const name = button.dataset.bookingName || '';

      locationsView.hidden = true;
      calendarView.hidden = false;
      calendarTitle.textContent = name;
      iframe.hidden = true;
      fallback.hidden = true;
      unavailable.hidden = true;

      if (!url && !fallbackUrl) {
        unavailable.hidden = false;
        return;
      }

      if (url && canEmbed(url)) {
        iframe.title = name ? `${iframeBaseTitle} — ${name}` : iframeBaseTitle;
        iframe.src = embedUrl(url);
        iframe.hidden = false;
        return;
      }

      externalLink.href = url || fallbackUrl;
      fallback.hidden = false;
    }

    openButton.addEventListener('click', () => {
      dialog.showModal();
      const firstLocation = locationButtons[0];
      if (firstLocation) firstLocation.focus();
    });

    closeButton.addEventListener('click', () => dialog.close());
    backButton.addEventListener('click', resetCalendar);

    locationButtons.forEach((button) => {
      button.addEventListener('click', () => openLocation(button));
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', resetCalendar);
  }

  document.querySelectorAll('[data-bespoke-booking]').forEach(initializeBespokeBooking);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-bespoke-booking]');
    if (section) initializeBespokeBooking(section);
  });

  window.addEventListener('message', (event) => {
    if (event.origin !== 'https://calendly.com') return;
    if (event.data?.event !== 'calendly.event_scheduled') return;

    window.dispatchEvent(new CustomEvent('cocoleni:appointment-booked', {
      detail: event.data.payload
    }));

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: 'bespoke_appointment_booked' });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
